<template>
    <div class="w-100 h-100">
        <div class="row h-100">
            <div class="col-lg-12 d-flex flex-column h-100">
                <div class="np-group">
                    <div class="np-group np-group-column np-flex-1 np-pb-4">
                        <div class="np-header2  vertical-align-center np-pt-2">
                            <svg class="np-mr-2"><use href="@/assets/images/icons/folder2.svg#icon"></use></svg> {{ $t("UI.files.files") }}
                        </div>
                        <div class="np-group np-group-row np-pt-3">
                            <div class="np-field-group np-with-icon-right">
                                <input type="text" class="np-text-input np-outline" placeholder="Поиск" v-model="filters.name"/>
                                <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                            </div>                                                                      
                        </div>
                    </div>

                    <div class="np-group np-group-column np-pb-4">
                        <div class="np-header2 vertical-align-center np-pb-3">
                            <svg class="np-mr-2"><use href="@/assets/images/icons/pressure.svg#icon"></use></svg> {{ $t("UI.files.availableSpace") }}
                        </div>
                        <div class="np-panel">
                            <div class="np-panel-body">
                                <div class="np-group justify-content-between align-items-center">
                                    <span class="pb-1">{{ usedSpace.usagePercent }}% из {{ formatBytes(usedSpace.maxSpace) }}</span>
                                    <span class="np-font-s ms-4 pb-1">{{ $t("UI.files.available") }} {{ formatBytes(usedSpace.recentSpace) }}</span>
                                </div>
                                <div class="np-progressbar">
                                    <div class="np-progressbar-track" :style="{'width': (usedSpace.usagePercent) +'%', 'max-width': '100%'}"></div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="np-panel np-flex-1 np-overflow-hidden">
                    <PerfectScrollbar>
                        <table class="np-table h-100">
                            <thead class="np-table-header">
                                <tr class="np-table-row">
                                    <th class="np-table-header-cell text-start np-color-primary-500" style="width: 86px;">
                                        <button class="np-btn-link np-color-primary-600" @click="onFileSelectAll">
                                            <svg v-if="selectedFiles.length == filesList.files.length" ><use href="@/assets/images/icons/checked4.svg#icon"></use></svg>
                                            <svg v-else><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>
                                        </button>
                                    </th>                                     
                                    <th class="np-table-header-cell" style="width: 15%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.fileName") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('title')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('title')" /> 
                                            </button>
                                        </div>
                                    </th>                                    
                                    <th class="np-table-header-cell" style="width: 12%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.attachToTask") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('title')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('title')" /> 
                                            </button>
                                        </div>
                                    </th>
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.size") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('deadline')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('deadline')" /> 
                                            </button>
                                        </div>
                                    </th>                                                          
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.type") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('status')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('status')" /> 
                                            </button>
                                        </div>
                                    </th>  
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.date") }}</div>
                                            <button class="np-btn-link">
                                                <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/list2.svg#icon"></use></svg> 
                                            </button>
                                        </div>
                                    </th>                                                         
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.version") }}</div>
                                            <button class="np-btn-link">
                                                <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/list2.svg#icon"></use></svg> 
                                            </button>
                                        </div>
                                    </th>   
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.changedAt") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('priority')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('priority')" /> 
                                            </button>
                                        </div>
                                    </th>   
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.addedAt") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_start')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_start')" />  
                                            </button>
                                        </div>
                                    </th>                                             
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.files.changedBy") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_end')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_end')" /> 
                                            </button>
                                        </div>
                                    </th> 
                                    <th class="np-table-header-cell" style="width: 135px;">
                                    </th>                                                                                                                                                       
                                </tr>
                            </thead>
                            <tbody class="np-table-body">
                                <tr class="np-table-fixed-row" v-if="selectedFiles.length > 0">
                                    <td colspan="11">
                                        <div class="np-group">
                                            <div class="np-group align-items-center np-flex-1">
                                                <button class="np-btn-link np-color-primary-600 ms-2 me-2" @click="onFileDeselectAll()">
                                                    <svg><use href="@/assets/images/icons/checked-uncheck-all.svg#icon"></use></svg>
                                                </button>
                                                <span>
                                                    Выбрано {{ selectedFiles.length }} 
                                                </span>                                                
                                            </div>
                                            <div class="np-group align-items-center p-1">
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/unlock.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.lock") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/download.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.download") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/download.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.downloadAll") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-danger np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/trash.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.delete") }}
                                                </button>                                                                                                                                                                             
                                            </div>   
                                        </div>
                                    </td>
                                </tr>
                                <template v-for="eFile in filesList.files">
                                    <tr class="np-table-row">
                                        <td class="np-table-cell">
                                            <div class="np-group align-items-center np-color-primary-600">
                                                <button class="np-btn-link np-color-primary-600" @click="onFileSelect(eFile.id)">
                                                    <svg v-if="eFile.selected" ><use href="@/assets/images/icons/checked4.svg#icon"></use></svg>
                                                    <svg v-else><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>
                                                </button>

                                                <FilePreview 
                                                    :fileUrl="Config.SERVER + 'web/' + eFile.filePath"
                                                    :altText="eFile.name"
                                                    @click="showViewer(eFile.id)"
                                                />
                                            </div>
                                        </td>
                                        <td class="np-table-cell">
                                            <div class="np-group justify-content-between align-items-center" role="button" @click="showViewer(eFile.id)">
                                                <div class="flex-grow-1 np-ellipsis np-font-s">
                                                    {{ eFile.name }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="np-table-cell">
                                            {{ eFile.taskTitle }}
                                        </td>
                                        <td class="np-table-cell text-center">{{ formatBytes(eFile.fileSize) }}</td>
                                        <td class="np-table-cell text-center">{{ "." + eFile.name.split(".")[1] }}</td>
                                        <td class="np-table-cell"></td>
                                        <td class="np-table-cell text-center">v1.0</td>
                                        <td class="np-table-cell"></td>
                                        <td class="np-table-cell"></td>
                                        <td class="np-table-cell"></td>
                                        <td class="np-table-cell">
                                            <div class="np-group">
                                                <button class="np-btn-link np-color-primary me-1" @click="showViewer(eFile.id)"><svg><use href="@/assets/images/icons/eye2.svg#icon"></use></svg></button>
                                                <button class="np-btn-link np-color-primary me-1"><svg><use href="@/assets/images/icons/unlock.svg#icon"></use></svg></button>
                                                <a class="np-btn-link np-color-primary me-1" target="_blank" :download="eFile.filePath" :href="Config.SERVER + 'web/' + eFile.filePath">
                                                    <svg><use href="@/assets/images/icons/download.svg#icon"></use></svg>
                                                </a>
                                                <button class="np-btn-link np-color-danger" @click="onFileDelete(eFile.id, eFile.subTaskId)"><svg><use href="@/assets/images/icons/trash.svg#icon"></use></svg></button>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>                                                                                         
                        </table>
                    </PerfectScrollbar>
                </div>
            </div>
        </div>            
    </div>
    <ViewerModal modalID="modalIDVwr" ref="VwrModal" />
    <DelModal modalID='modalIDelFile'  modalPosition="center" ref="DelFileModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ deleteType.title }}</template>
        <template v-slot:body>
            <div class="modal-body">
                <h2>{{ $t("UI.confirmation") }}</h2>
            </div>
            <div class="modal-footer ps-0 pe-0">
                <button type="button" class="btn btn-outline-secondary btn-sm me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="btn btn-danger btn-sm" @click="deleteAll">{{ $t("UI.delete") }}</button>
            </div>
        </template>
    </DelModal>    
</template>

<script>

import { localeDate, localeDateTime, formatBytes } from '@/utils/format'
import TaskCardSimple  from "@/components/TaskCardSimple.vue" 
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import FilePreview from '@/components/elements/FilePreview.vue'
import ViewerModal from "@/components/modals/ViewerModal.vue"
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../../config.js'
import { confirm } from "@/utils/confirmation.js";

function compareValues(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true })
  }
  if (a < b) return -1
  if (a > b) return 1
  return 0
}

function sortByMultipleFields(array, sorts) {
    return array.sort((a, b) => {

        const activeSorts = Object.entries(sorts)
        .filter(([field, direction]) => direction !== 'none')
        .map(([field, direction]) => ({ field, direction }))

        for (const { field, direction } of activeSorts) {
            const multiplier = direction === 'desc' ? -1 : 1

            let valueA, valueB
            if (field === 'status') {
                valueA = a.status.title
                valueB = b.status.title
            } else if (field === 'deadline') {
                valueA = daysTo(a.task.date_planned_end, a.task.date_actual_end)
                valueB = daysTo(b.task.date_planned_end, b.task.date_actual_end) 
            } else if (field === 'priority') {
                valueA = priorityTo(a.task.priority)
                valueB = priorityTo(b.task.priority)
            } else {                    
                valueA = a.task[field]
                valueB = b.task[field]
            }

            const result = compareValues(valueA, valueB)
            if (result !== 0) return result * multiplier
        }

        return 0
    })
}

export default {
    emits: ['showModTask', 'refresh'],
    components: {
        TaskCardSimple,
        CobaltProfile,
        VueSlider,
        IndicatorDaysTo,
        FilePreview,
        ViewerModal
    },
    props: {
        project: {
            type: Object,
            default: {}
        },      
        statuses: {
            type: Array,
            default: []
        },             
        users: {
            type: Array,
            default: []
        },            
        priorityValues: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            Config,
            compInfo: null,
            filesFilter: '',
            filterVisible: false,
            filters: {
                name: '',
                deadline: null,
                status: '',
                percent: 100,
                performers: [],
                priority: [],
                files: 0,
                date_planned_start: null,
                date_planned_end: null
            },
            sorts: {
                name: 'none',
                task: 'none',
                size: 'none',
                type: 'none',
                version: 'none',
                date_created_at: 'none',
                date_updated_at: 'none',
                user_created: 'none',
                user_updated: 'none',
            },
            localStatuses: JSON.parse(JSON.stringify(this.statuses)),
            selectedFiles: [],
            fileToDelete: 0,
            deleteFromSubtask: false
        }
    },
    computed: {     
        filesList: {
            get() {
                const searchTerm = this.filters.name.trim().toLowerCase()
                const fieldsToSearch = ['taskTitle', 'name']
                let list = []
                let usedSpace = 0

                this.localStatuses.forEach(element => {
                    element.tasks.forEach(taskItem => {
                        taskItem.files.forEach(fileItem => {
                            const selected = this.selectedFiles.indexOf(fileItem.id) != -1
                            let item = { "selected": selected, "statusId": element.id, "taskTitle": taskItem.title, "taskId": taskItem.id, "subTaskId": 0, ... fileItem }
                            list.push(item)
                            usedSpace += fileItem.fileSize
                        })
                        taskItem.subtask.forEach(subTaskItem => {
                            subTaskItem.files.forEach(stFileItem => {
                                const selected = this.selectedFiles.indexOf(stFileItem.id) != -1
                                let item = { "selected": selected, "statusId": element.id, "taskTitle": taskItem.title, "taskId": taskItem.id, "subTaskId": subTaskItem.id, ... stFileItem }
                                list.push(item)
                                usedSpace += stFileItem.fileSize
                            })                            
                        })
                    })
                })

                const sortedTasks = sortByMultipleFields(list, this.sorts)

                const result = sortedTasks.filter(item => {
                    return fieldsToSearch.some(field => 
                        String(item[field]).toLowerCase().includes(searchTerm)
                    )
                })

                return { "usedSpace": usedSpace, "files": result }
            }
        },
        usedSpace: {
            get() {
                return {
                    "maxSpace": Config.MAX_SPACE,
                    "usagePercent": Math.round((this.filesList.usedSpace / Config.MAX_SPACE) * 100),
                    "recentSpace": Config.MAX_SPACE - this.filesList.usedSpace
                }
            }
        }         
    },
    methods: {
        ...mapActions('company', ['list']),
        ...mapGetters('company', ['getList']),     
        ...mapActions('board', ['deleteFile', 'deleteSubFile']),

        localeDate,
        localeDateTime,  
        formatBytes,       

        getPriority(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority)
            return priorityObj
        }, 
        sortIcon(field) {
            const direction = this.sorts[field]
            if (direction === 'asc') {
                return require('@/assets/images/icons/sort-asc.svg#icon')
            } else if (direction === 'desc') {
                return require('@/assets/images/icons/sort-desc.svg#icon')
            } else if (direction === 'none') {
                return require('@/assets/images/icons/sort-none.svg#icon')
            }
            return ''
        },
        attachSorting(field) {           
            if (!(field in this.sorts)) {
                console.error(`Поле "${field}" не существует в объекте sorts.`)
                return
            }

            Object.keys(this.sorts).forEach((key) => {
                if (key !== field) {
                    this.sorts[key] = 'none'
                }
            })
            
            const currentValue = this.sorts[field];

            if (currentValue === 'none') {
                this.sorts[field] = 'asc'
            } else if (currentValue === 'asc') {
                this.sorts[field] = 'desc'
            } else {
                this.sorts[field] = 'none'
            }
        },           
        showFilters() {
            this.filterVisible = !this.filterVisible
        }, 
        showModTask(taskId, statusId, taskActiveTab="params", activeSubTaskID=null) {
            this.$emit('showModTask', taskId, statusId, taskActiveTab, activeSubTaskID)
        },   
        showViewer(id) {
            this.$refs.VwrModal.shows(id, [...this.filesList.files])
        }, 
        onFileDeselectAll() {
            this.selectedFiles = []
        },
        onFileSelect(id) {
            if (this.selectedFiles.indexOf(id) != -1) {
                this.selectedFiles = this.selectedFiles.filter(_id => _id !== id)
            } else {
                this.selectedFiles.push(id)
            }
        },
        onFileSelectAll() {
            if (this.selectedFiles.length == this.filesList.files.length) {
                this.selectedFiles = []
            } else {
                this.selectedFiles = []
                this.filesList.files.forEach(item => {
                    this.selectedFiles.push(item.id)
                })      
            }      
        },        
        onFileDeselectAll() {
            this.selectedFiles = []
        },                    
        async onFileDelete(fileId, subTaskId) {
            const confirmed = await confirm("Подтверждение", "Вы уверены, что хотите удалить?", this.$t("UI.ok"), this.$t("UI.cancel"))

            if (!confirmed) return

            this.doDeleteFile(fileId, !!subTaskId)
            this.localStatuses.forEach(status => {
                status.tasks.forEach(task => {
                    task.files = task.files.filter(file => file.id !== fileId)

                    task.subtask.forEach(subTask => {
                        subTask.files = subTask.files.filter(file => file.id !== fileId)
                    })
                })
            })

            this.refresh()
        },  
        async doDeleteFile(id, fromSubtask) {
            try {
                if (fromSubtask) {
                    this.deleteSubFile(id)
                } else {
                    this.deleteFile(id)
                }                
            } catch (error) {
                console.error('Error removing files:', error)
            }
        },           
        refresh() {
            this.$emit('refresh')
        }          
    }

}
</script>

<style scoped>
</style>